import React from "react";
import MatchKeysBlock from "./MatchKeysBlock";

export default function DateToleranceBlock({ rule, index, onChange }) {
  return (
    <div style={{ marginBottom: "1rem", padding: "0.75rem", background: "#ECFDF5", border: "1px solid #A7F3D0", borderRadius: "0.5rem" }}>
      <MatchKeysBlock rule={rule} index={index} onChange={onChange}
        listKey="date_keys" label="Date columns with ±N days tolerance"
        testidPrefix="date" addLabel="Add date pair" />
      <div style={{ marginTop: "0.5rem" }}>
        <label style={{ fontSize: "0.7rem", color: "#065F46", display: "block", marginBottom: "0.2rem" }}>Tolerance (± days)</label>
        <input data-testid={`date-days-${index}`} type="number" min="0" className="recon-input" style={{ fontSize: "0.8rem", width: "140px" }}
          value={rule.date_tolerance_days ?? 0}
          onChange={e => onChange({ ...rule, date_tolerance_days: parseInt(e.target.value) || 0 })} />
        <span style={{ fontSize: "0.72rem", color: "var(--text-muted)", marginLeft: "0.5rem" }}>
          Parses common date formats (ISO, US, EU)
        </span>
      </div>
    </div>
  );
}
